import React, { useRef, useEffect, useState } from 'react';
import { Button, Modal, Tooltip, OverlayTrigger, Badge, Dropdown } from 'react-bootstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import vendor_1 from '../../../../images/vendor/vendor_1.jpg';
import vendor_2 from '../../../../images/vendor/vendor_2.jpg';
import vendor_3 from '../../../../images/vendor/vendor_3.jpg';
import axios from "axios";

const Vendor_Outstanding = ({ show, onClose }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // page table data fetch
    const fetchData = () => {
        
        axios.get(`${baseURL}/dropdown/vendor`)
            .then(response => {
                setData(response.data.vendors);
                setHasFetched(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    // fetch data
    useEffect(() => {
        fetchData();
    }, []);


    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const tableRef = useRef(null);

    useEffect(() => {
        if(hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        "ordering": false,
                        paging: false,
                        scrollY: "250px", // Set the scroll height here
                        scrollCollapse: true,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    //format date
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Vendor Outstanding</h3>
                    <Button variant="" type="button" className="close px-6 py-1" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="table-container">
                        <table ref={tableRef} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                  <OverlayTrigger
                                        trigger="hover"
                                        placement="bottom"
                                        overlay={
                                            <Tooltip className="tooltip-popover">
                                                <span className="fs-8 text-white fw-semibold">Last Purchased Date</span>
                                            </Tooltip>
                                        }
                                    ><th className='text-start'>Date</th></OverlayTrigger>
                                    <th>Vendors</th>
                                    {/* <th>Mobile No/Email id</th> */}
                                    <OverlayTrigger
                                        trigger="hover"
                                        placement="bottom"
                                        overlay={
                                            <Tooltip className="tooltip-popover">
                                                <span className="fs-8 text-white fw-semibold">Contact Person / Mobile No</span>
                                            </Tooltip>
                                        }
                                    ><th>Contact</th></OverlayTrigger>

                                    <OverlayTrigger
                                        trigger="hover"
                                        placement="bottom"
                                        overlay={
                                            <Tooltip className="tooltip-popover">
                                                <span className="fs-8 text-white fw-semibold">Settlement Type / Business Type</span>
                                            </Tooltip>
                                        }
                                    ><th className='text-start'>Settl/Buss.</th></OverlayTrigger>
                                    <th>Outstanding Amt</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                {datas.map((data, index) => (
                                    <tr key={data.sno}>
                                        <td>
                                            <label className='text-danger font-w500 fs-7'>{formatDate(data.created_at)}</label>
                                        </td>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={data.vendor_image || vendor_1} className='border rounded px-1 py-0'>
                                                        <img src={data.vendor_image || vendor_1} alt="vendor" className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <OverlayTrigger
                                                        trigger={['hover', 'focus']}
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip className="toltip-popover">
                                                                <span className="fs-8 text-white">Business Name</span>
                                                            </Tooltip>
                                                        }
                                                    ><label className='text-black font-w400 fs-7'>{data.vendor_businessname}</label></OverlayTrigger>
                                                    <div className="d-block">
                                                        <OverlayTrigger
                                                            trigger={['hover', 'focus']}
                                                            placement="bottom"
                                                            overlay={
                                                                <Tooltip className="toltip-popover">
                                                                    <span className="fs-8 text-white">Category</span>
                                                                </Tooltip>
                                                            }
                                                        ><label className="fs-8 text-dark font-w600">{data.vendor_category_name}</label></OverlayTrigger>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>{data.person_name}</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-dark font-w600">{data.vendor_mobileno}</label>
                                            </div>
                                        </td>
                                        <td className='text-start'>
                                            <label className='text-black fs-7 py-0 px-1'>{data.business_type}</label>
                                            <label bg="warning" className='text-gray fs-8 py-0 px-1 d-block'>
                                                {data.settlement_type}{' '}
                                                {data.select_type === 0 ? 'Weeks' :
                                                data.select_type === 1 ? 'Months' :
                                                data.select_type === 2 ? 'Years' :
                                                ''}
                                            </label>
                                        </td>
                                        <td>
                                            <label className="fs-6 fw-bold text-danger">
                                                <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                {new Intl.NumberFormat('en-IN').format(data.opening_balance_amount)}
                                            </label>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Vendor_Outstanding;
